export default __webpack_public_path__ + "static/media/landing-img6.62bacf60.png";